import styled from "@emotion/styled";
import Chip, { chipClasses } from "@mui/material/Chip";
import { alpha, MenuItem } from "@mui/material";

export const StyledChip = styled(Chip)(({ theme }) => ({
	marginRight: "0.5rem",
	[`&.${chipClasses.root}`]: {
		"&:hover": {
			color: theme.project.colors.primaryColors.main,
			borderColor: alpha(theme.project.colors.primaryColors.main, 0.08)
		}
	},
	[`.${chipClasses.label}`]: {
		paddingTop: "3px",
		fontSize: ".938rem",
		maxWidth: "200px"
	},
	[`.${chipClasses.deleteIcon}`]: {
		color: theme.project.colors.primaryColors.main,
		"&:hover": {
			color: theme.project.colors.primaryColors.main
		}
	},
	[`&.${chipClasses.colorPrimary}`]: {
		backgroundColor: theme.project.colors.secondaryColors.primary,
		borderStyle: "solid",
		borderWidth: 1,
		fontWeight: 500,
		color: theme.project.colors.fontColors.main,
		borderColor: theme.project.colors.allColors.hex.grayscale.gray400
	},
	[`&.${chipClasses.colorSecondary}`]: {
		borderWidth: 1,
		borderStyle: "solid",
		fontWeight: 500,
		color: theme.project.colors.primaryColors.main,
		backgroundColor: alpha(theme.project.colors.primaryColors.main, 0.08),
		borderColor: alpha(theme.project.colors.primaryColors.main, 0.08)
	}
}));

export const MenuItemWrapper = styled(MenuItem)({
	whiteSpace: "unset",
	wordBreak: "break-word"
});

export const MenuItemContentWrapper = styled.div({
	alignItems: "center",
	boxSizing: "border-box",
	display: "flex",
	justifyContent: "space-between",
	width: "400px",
	[".MuiFormControlLabel-root"]: {
		margin: 0,
		width: "100%",
		overflow: "hidden",
		[".MuiCheckbox-root"]: {
			alignSelf: "center"
		}
	}
});

export const FiltersContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	width: "100%"
});

export const ChipAndExportContainer = styled.div({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	gap: "16px"
});

export const ResultsAndSearchContainer = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: "16px"
	}
}));

export const ResultsText = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	fontSize: "14px",
	color: theme.project.colors.fontColors.main,
	marginTop: "8px"
}));

export const SearchContainer = styled.div(({ theme }) => ({
	backgroundColor: "transparent",
	minWidth: "378px",
	"& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder": {
		color: theme.project.colors.fontColors.tertiary,
		opacity: 1
	},
	[theme.breakpoints.down("md")]: {
		minWidth: "auto"
	}
}));
